import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import router from "./router";
import VueGtag from "vue-gtag";
import '@stripe/stripe-js';

Vue.use(VueRouter)

// Development mode
if (location.hostname.match(/(rach.kings.kucits.ca)|(tomo.kings.kucits.ca)/gi)) {
  Vue.config.devtools = true
  Vue.config.productionTip = false
} else {
  // Production
  Vue.use(VueGtag, {
    config: {
      id: "G-N9CN2Q5WRE"
    },
    appName: 'Residence App',
    pageTrackerScreenviewEnabled: true
  }, router);
}

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')